module.exports = __webpack_public_path__ + "img/frontend.7e80f229.png";